import { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { Header, AuthLink, FormContainer } from './shared'
import SetPasswordForm from './SetPasswordForm'

const Wrapper = styled.div``

class SetPassword extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const { location } = this.props
    return (
      <Wrapper>
        <Header>
          <AuthLink to="/set-password">
            <strong>Set</strong> Password
          </AuthLink>
        </Header>
        <FormContainer>
          <SetPasswordForm location={location} />
        </FormContainer>
      </Wrapper>
    )
  }
}

export default connect()(SetPassword)
